import { render, staticRenderFns } from "./ServiceStep.vue?vue&type=template&id=bed18596&scoped=true"
import script from "./ServiceStep.vue?vue&type=script&lang=js"
export * from "./ServiceStep.vue?vue&type=script&lang=js"
import style0 from "./ServiceStep.vue?vue&type=style&index=0&id=bed18596&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bed18596",
  null
  
)

export default component.exports